import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import { LanguagesListWrapper } from './languages-list/LanguagesList'
import AccountPage from '../../modules/accounts/AccountPage'
import { AccountHeader } from '../../modules/accounts/AccountHeader'
import { Settings } from '../../modules/accounts/components/settings/Settings'
import { Overview } from '../../modules/accounts/components/Overview'

const languagesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Language Management',
    path: '/admin/pages/languages',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const accountBreadCrumbs: Array<PageLink> = [
  {
    title: 'Account',
    path: '/admin/pages/languages/overview',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const LanguagesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          // path='languages'
          index
          element={
            <>
              <PageTitle breadcrumbs={languagesBreadcrumbs}>Languages list</PageTitle>
              <LanguagesListWrapper />
            </>
          }
        />

        <Route
          element={
            <>
              <AccountHeader />
              <Outlet />
            </>
          }
        >
          <Route
            path='overview'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <Overview />
              </>
            }
          />
          <Route
            path='settings'
            element={
              <>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Settings</PageTitle>
                <Settings />
              </>
            }
          />
          <Route index element={<Navigate to='/admin/pages/languages/overview' />} />
        </Route>

      </Route>
      <Route index element={<Navigate to='/admin/pages/languages' />} />
    </Routes>
  )
}

export default LanguagesPage
